<template>
    <modal-component
      :active="active"
      @cancel="close"
      :titleModal="item.name"
      :disabled="loading"
      :loader="loading"
      :isMessage="true"
      :actionCenter="true"
       widthModal="width: 70%"
    >
      <div class="has-text-confirmation" v-html="item.content">
      </div>
    </modal-component>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import mixins from '../../../mixins/formats'

export default {
  components: {
    ModalComponent: () => import('@/components/ui/ModalComponent')
  },
  mixins: [mixins],
  props: {
    item: {
      type: Object
    },
    active: {
      type: Boolean,
      default: false
    },
    close: {
      type: Function,
      detault: () => {}
    }
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    ...mapActions([])
  },
  computed: {
    ...mapState({
      systemConfiguration: state => state.configuration,
      profile: state => state.financialCompany.financialCompany
    })
  }
}
</script>

<style lang="scss" scoped>
.has-text-confirmation {
  padding-left: 1rem;
  padding-right: 1rem;
}
</style>
